<div class="export-report-dialog">
  <div class="export-report-dialog-header flex-between-center">
    <p class="m-0 font-bold">{{ filterState.isPrint ? 'Print Report' : 'Export' }}</p>
    <span class="close-modal">
      <i class="fal fa-times" (click)="closeModal()"></i>
    </span>
  </div>

  <div class="export-report-dialog-body flex-column flex-wrap flex-start-start">
    <div class="mb-2 export-col-check" *ngFor="let col of columns; let colIndex = index">
      <app-checkbox [label]="col.name" [isChecked]="col.isChecked" (appChange)="handleCheckChange(colIndex, $event)"> </app-checkbox>
    </div>
  </div>

  <div class="export-report-dialog-footer flex-between-center">
    <div>
      <app-checkbox
        label="Show the applied filters on the report"
        *ngIf="filterState.isPrint && id !== printReportLabel.dailyPayment"
        [isChecked]="isFiltersApply"
        (appChange)="handleChange($event)"
      ></app-checkbox>
    </div>
    <div>
      <!-- {{processing}}
      {{!hasCheckedColumns()}} -->
      <button class="btn btn-border pointer btn-submit mr-1" (click)="closeModal()">Cancel</button>
      <button class="btn btn-primary btn-submit" [disabled]="processing || !hasCheckedColumns() || finalData.length === 0" (click)="downloadExcel()" 
      *ngIf="!filterState.isPrint">
        Download Excel
        <i class="fal fa-spinner rotate" *ngIf="processing"></i>
      </button>

      <button class="btn btn-primary btn-submit" *ngIf="filterState.isPrint" [disabled]="finalData.length === 0" (click)="handlePrint()">
        Print
        <i class="fal fa-spinner rotate" *ngIf="processing"></i>
      </button>
    </div>
  </div>
</div>
